export const IconArrowDown = () => {
    return (
        <svg
            width="6"
            height="14"
            viewBox="0 0 6 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.68198 0C2.95812 0 3.18198 0.223858 3.18198 0.5V2.0625C3.18198 2.33864 2.95812 2.5625 2.68198 2.5625C2.40584 2.5625 2.18198 2.33864 2.18198 2.0625V0.5C2.18198 0.223858 2.40584 0 2.68198 0ZM2.68198 4.6875C2.95812 4.6875 3.18198 4.91136 3.18198 5.1875V8.3125C3.18198 8.58864 2.95812 8.8125 2.68198 8.8125C2.40584 8.8125 2.18198 8.58864 2.18198 8.3125V5.1875C2.18198 4.91136 2.40584 4.6875 2.68198 4.6875ZM5.21751 11.1716L3.03553 13.3536C2.84027 13.5488 2.52369 13.5488 2.32843 13.3536L0.146447 11.1716C-0.0488155 10.9763 -0.0488155 10.6597 0.146447 10.4645C0.341709 10.2692 0.658291 10.2692 0.853553 10.4645L2.18198 11.7929V11.4375C2.18198 11.1614 2.40584 10.9375 2.68198 10.9375C2.95812 10.9375 3.18198 11.1614 3.18198 11.4375V11.7929L4.51041 10.4645C4.70567 10.2692 5.02225 10.2692 5.21751 10.4645C5.41278 10.6597 5.41278 10.9763 5.21751 11.1716Z"
                fill="#7F8898"
            />
        </svg>
    );
};

export default IconArrowDown;
